import axios from "@/libs/api.request";
// 获取列表
export const getCod = data => {
  return axios.request({
    url: "/finance/cod/branch/order",
    method: "post",
    data
  });
};

export const getSearchConfig = () => {
  return axios.request({
    url: "/finance/cod/branch/order/searchConfig",
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/yt/createClientCheckBill",
    method: "post",
    data
  });
};

export const cancelHangStatus = data => {
  return axios.request({
    url: "/finance/cod/branch/order/cancelHangStatus",
    method: "post",
    data
  });
};

export const hang = data => {
  return axios.request({
    url: "/finance/cod/branch/order/batchException",
    method: "post",
    data
  });
};

export const submitRemarks = data => {
  return axios.request({
    url: "/finance/cod/branch/order/batchRemarks",
    method: "post",
    data
  });
};

export const addResCod = data => {
  return axios.request({
    url: "/finance/branch/checkBill/yt/createClientCheckBill",
    method: "post",
    data
  });
};

// 生成银行手续费账单
export const createBankFeeBill = data => {
  return axios.request({
    url: "/finance/CodBankBill/create",
    method: "post",
    data
  });
};

// 获取COD币种
export const getCodCurrency = params => {
  return axios.request({
    url: "/finance/CodBankBill/currency",
    method: "get",
    params
  });
};

export const createAtAgentBill = data => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/ys/createAtAgentBill",
    method: "post",
    data
  });
};  